<template>
  <section>
    <header>
      <h2>あの「東京タラレバ娘」や「海月姫」の原作者<br class="break-xs">東村アキコ先生が<br>学生時代から愛用されている<br class="break-xs">「とり野菜みそ」のエッセイ漫画を描き下ろし！<br>超！超！超！レアな「まつや」オリジナル漫画を<br class="break-xs">全5話完結で順次公開いたします！</h2>
    </header>

    <ul>
      <li>
        <a href="comic001" class="open" target="_blank" ref="link"><img src="../assets/images/btn_commic001.svg" alt="第1話"></a>
      </li>
      <li>
        <a href="comic002" class="open" target="_blank" ref="link2"><img src="../assets/images/btn_commic002.svg" alt="第2話"></a>
      </li>
      <li>
        <a href="comic003" class="open" target="_blank" ref="link3"><img src="../assets/images/btn_commic003.svg" alt="第3話"></a>
      </li>
      <li>
        <a href="comic004" class="open" target="_blank" ref="link3"><img src="../assets/images/btn_commic004.svg" alt="第4話"></a>
      </li>
      <li>
        <div class="balloon">
          <img src="../assets/images/img_comic_balloon_new.svg" alt="最新話">
        </div>
        <a href="comic005" class="open" target="_blank" ref="link3"><img src="../assets/images/btn_commic005.svg" alt="第5話"></a>
      </li>
    </ul>
  </section>
</template>

<script>
  export default {
    name: 'Commic',

    mounted () {
      this.removeAttribute()
    },

    methods: {
      removeAttribute () {
        const ua = window.navigator.userAgent

        if (ua.indexOf('iPhone') !== -1 || ua.indexOf('iPad') !== -1 || ua.indexOf('Android') !== -1 || ua.indexOf('Mobile') !== -1) {
          this.$refs.link.removeAttribute('target')
          this.$refs.link2.removeAttribute('target')
          this.$refs.link3.removeAttribute('target')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";

  .break-xs {
    @include media( sm ) {
      display: none;
    }
  }

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 4vw;
  }

  header {
    h2 {
      margin-top: .5em;
      font: {
        size: 1.25rem;
        weight: 600;
      }
      line-height: 1.75;

      @include media( sm ) {
        font-size: 1.7rem;
      }

      @include media( md ) {
        font-size: 2.1rem;
      }
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 700px;

    @include media( sm ) {
      flex-direction: row;
      align-items: stretch;
    }

    @include media( md ) {
      max-width: 1000px;
    }
  }

  li {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin: 15px 2.5px;
    font: {
      size: 1.5rem;
      weight: 600;
    }
    line-height: 1;

    @include media( sm ) {
      margin: 50px 5px;
      font-size: 1.8rem;
    }

    @include media( md ) {
      font-size: 2.3rem;
    }
  }

  .balloon {
    width: 110px;
    line-height: 0;
    transform: translate(-4px, 14px);

    @include media( sm ) {
      width: 154px;
    }

    @include media( md ) {
      width: 220px;
    }

  }

  a {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 20px;
    width: 157px;
    height: 105px;
    background: url("../assets/images/btn_comic.svg") 50% 50% no-repeat;
    background-size: contain;

    @include media( sm ) {
      width: 220px;
      height: 146px;
      padding-bottom: 28px;
    }

    @include media( md ) {
      width: 304px;
      height: 202px;
      padding-bottom: 36px;
    }

    &.open {
      background-image: url("../assets/images/btn_comic_open.svg");
      cursor: pointer;
      transition: background-image 200ms ease 100ms;

      @include media(lg) {
        &:hover {
          background-image: url("../assets/images/btn_comic_hover.svg");
        }
      }
    }

    img {
      width: 86px;

      @include media( sm ) {
        width: 116px;
      }

      @include media( md ) {
        width: 184px;
      }
    }
  }

  mark {
    position: absolute;
    left: 14%;
    bottom: 60.5%;
    padding: .3em .3em .2em;
    color: #fff000;
    line-height: .9;
    background-color: #007733;
    transform: rotate(-9deg);

    @include media(sm) {
      bottom: 39.5%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/comic.vue?da64dc5a